var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurtleries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.75V7.75H10.875V12.75H12.125V0.25C10.4 0.25 9 1.65 9 2.75ZM5.875 4.625H4.625V0.25H3.375V4.625H2.125V0.25H0.875V4.625C0.875 6.00625 1.99375 7.125 3.375 7.125V12.75H4.625V7.125C6.00625 7.125 7.125 6.00625 7.125 4.625V0.25H5.875V4.625Z",
    fill: "#777E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurtleries);
export default __webpack_public_path__ + "static/media/curtleries.f486b568af968640fd41244660c47ee8.svg";
export { ForwardRef as ReactComponent };